import { text_mod_1, } from "./text/Text";
export const author_info = {
    title:
        "Інформація про підручники",
    questions: [
        {
            id: 1,
            onlyText: true,
            text: text_mod_1,
        },
    ]
}
